import Strings from '../common/Strings';
import { migrateUser, migrateProject, migrateWorkLog } from './migrationHelper';

const firebase = require('firebase/app');
require('firebase/auth');
require('firebase/firestore');

const SOURCE_SERVER = { source: 'server' };
const MIGRATION_V1 = 1;
export const LATEST_MIGRATION = MIGRATION_V1;

function showMigrationError() {
  alert(Strings.ERROR.migration);
}

function migrationDone(user, callback) {
  if (user) {
    user.migration = LATEST_MIGRATION;

    firebase
      .firestore()
      .collection('users')
      .doc(user.uid)
      .set(user, { merge: true })
      .then(() => {
        callback();
      })
      .catch(() => {
        showMigrationError();
      });
  } else {
    callback();
  }
}

function migrateV1(user, callback) {
  return () => {
    // User migration
    migrateUser(user);

    firebase
      .firestore()
      .collection('users')
      .doc(user.uid)
      .set(user, { merge: true })
      .then(() => {
        firebase
          .firestore()
          .collection('projects')
          .where('ownerUid', '==', user.uid)
          .get(SOURCE_SERVER)
          .then(projectsSnapshot => {
            // Projects migration
            const projects = [];
            projectsSnapshot.forEach(doc => {
              const project = doc.data();
              project.id = doc.id;
              const migrated = migrateProject(project);
              if (migrated) {
                projects.push(project);
              }
            });

            const writeBatch = firebase.firestore().batch();
            projects.forEach(project => {
              const ref = firebase
                .firestore()
                .collection('projects')
                .doc(project.id);
              writeBatch.set(ref, project, { merge: true });
            });
            writeBatch
              .commit()
              .then(() => {
                // Worklogs migration
                firebase
                  .firestore()
                  .collection('workLogs')
                  .where('ownerUid', '==', user.uid)
                  .get(SOURCE_SERVER)
                  .then(workLogsSnapshot => {
                    const workLogs = [];
                    workLogsSnapshot.forEach(doc => {
                      const workLog = doc.data();
                      workLog.id = doc.id;
                      const migrated = migrateWorkLog(workLog);
                      if (migrated) {
                        workLogs.push(workLog);
                      }
                    });

                    const writeBatch2 = firebase.firestore().batch();
                    workLogs.forEach(workLog => {
                      const ref = firebase
                        .firestore()
                        .collection('workLogs')
                        .doc(workLog.id);
                      writeBatch2.set(ref, workLog, { merge: true });
                    });
                    writeBatch2
                      .commit()
                      .then(() => {
                        migrationDone(user, callback);
                      })
                      .catch(() => {
                        showMigrationError();
                      });
                  })
                  .catch(() => {
                    showMigrationError();
                  });
              })
              .catch(() => {
                showMigrationError();
              });
          })
          .catch(() => {
            showMigrationError();
          });
      })
      .catch(() => {
        showMigrationError();
      });
  };
}

export default function migrateAllData(callback) {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      firebase
        .firestore()
        .collection('users')
        .doc(currentUser.uid)
        .get()
        .then(doc => {
          if (doc.exists) {
            const user = doc.data();

            // TODO If more migrations come implement cycle logic here
            if (!user.migration || user.migration < MIGRATION_V1) {
              dispatch(migrateV1(user, callback));
            } else if (user.migration === LATEST_MIGRATION) {
              migrationDone(user, callback);
            }
          } else {
            migrationDone(null, callback);
          }
        })
        .catch(() => {
          showMigrationError();
        });
    } else {
      migrationDone(null, callback);
    }
  };
}



// WEBPACK FOOTER //
// ./src/migrations/migration.js